import { render, staticRenderFns } from "./PaymentDetailsPopover.vue?vue&type=template&id=31b3658f"
import script from "./PaymentDetailsPopover.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsPopover.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetailsPopover.vue?vue&type=style&index=0&id=31b3658f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports